import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// user-client-mod -- RegisterPage
//
// 用户自助注册页面，POST /api/users/register
// - 用户名、邮箱、密码、确认密码
// - 客户端校验（密码一致、最低长度）
// - 提交后 fetch API，成功跳转登录页，失败显示错误
import * as React from 'react';
export function RegisterPage() {
    const [error, setError] = React.useState();
    const [success, setSuccess] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [hydrated, setHydrated] = React.useState(false);
    // 确认 hydration 完成
    React.useEffect(() => {
        setHydrated(true);
        console.log('[RegisterPage] Hydrated ✓');
    }, []);
    async function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('[RegisterPage] handleSubmit called');
        setError(undefined);
        const formData = new FormData(e.currentTarget);
        const username = formData.get('username').trim();
        const email = formData.get('email').trim();
        const password = formData.get('password');
        const confirmPassword = formData.get('confirmPassword');
        console.log('[RegisterPage] Form data:', { username, email, passwordLength: password?.length, confirmLength: confirmPassword?.length });
        // 客户端基础校验
        if (!username || !email || !password) {
            console.log('[RegisterPage] Validation: empty fields');
            setError('请填写所有必填字段');
            return;
        }
        if (username.length < 3) {
            console.log('[RegisterPage] Validation: username too short');
            setError('用户名至少 3 个字符');
            return;
        }
        if (password.length < 8) {
            console.log('[RegisterPage] Validation: password too short');
            setError('密码至少 8 位');
            return;
        }
        if (password !== confirmPassword) {
            console.log('[RegisterPage] Validation: passwords mismatch');
            setError('两次输入的密码不一致');
            return;
        }
        setLoading(true);
        console.log('[RegisterPage] Sending request...');
        try {
            const res = await fetch('/api/users/register', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, email, password }),
            });
            console.log('[RegisterPage] Response status:', res.status);
            if (!res.ok) {
                const data = await res.json().catch(() => ({}));
                console.log('[RegisterPage] Error response:', data);
                setError(data.error || `注册失败 (${res.status})`);
                return;
            }
            console.log('[RegisterPage] Registration successful');
            setSuccess(true);
            // 注册成功后延迟跳转登录页
            setTimeout(() => { window.location.href = '/login'; }, 1500);
        }
        catch (err) {
            console.error('[RegisterPage] Fetch error:', err);
            setError(err.message || '注册请求失败，请稍后重试');
        }
        finally {
            setLoading(false);
        }
    }
    console.log('[RegisterPage] Render, hydrated:', hydrated, 'loading:', loading, 'error:', error, 'success:', success);
    if (success) {
        return (_jsxs("div", { className: "register-page", children: [_jsx("h1", { children: "\u6CE8\u518C\u6210\u529F" }), _jsx("p", { className: "success", children: "\u8D26\u53F7\u5DF2\u521B\u5EFA\uFF0C\u5373\u5C06\u8DF3\u8F6C\u5230\u767B\u5F55\u9875..." }), _jsxs("p", { children: ["\u6CA1\u6709\u81EA\u52A8\u8DF3\u8F6C\uFF1F", _jsx("a", { href: "/login", children: "\u70B9\u51FB\u6B64\u5904" })] })] }));
    }
    return (_jsxs("div", { className: "register-page", children: [_jsx("h1", { children: "\u6CE8\u518C" }), !hydrated && _jsx("div", { className: "debug-info", children: "Hydrating..." }), error && _jsx("div", { className: "error", children: error }), _jsxs("form", { onSubmit: handleSubmit, noValidate: true, children: [_jsxs("div", { className: "form-field", children: [_jsx("label", { htmlFor: "username", children: "\u7528\u6237\u540D" }), _jsx("input", { id: "username", name: "username", type: "text", placeholder: "\u8BF7\u8F93\u5165\u7528\u6237\u540D\uFF08\u81F3\u5C11 3 \u4E2A\u5B57\u7B26\uFF09", minLength: 3, required: true, autoComplete: "username" })] }), _jsxs("div", { className: "form-field", children: [_jsx("label", { htmlFor: "email", children: "\u90AE\u7BB1" }), _jsx("input", { id: "email", name: "email", type: "email", placeholder: "\u8BF7\u8F93\u5165\u90AE\u7BB1", required: true, autoComplete: "email" })] }), _jsxs("div", { className: "form-field", children: [_jsx("label", { htmlFor: "password", children: "\u5BC6\u7801" }), _jsx("input", { id: "password", name: "password", type: "password", placeholder: "\u8BF7\u8F93\u5165\u5BC6\u7801\uFF08\u81F3\u5C11 8 \u4F4D\uFF09", minLength: 8, required: true, autoComplete: "new-password" }), _jsx("small", { className: "hint", children: "\u5BC6\u7801\u81F3\u5C11 8 \u4F4D" })] }), _jsxs("div", { className: "form-field", children: [_jsx("label", { htmlFor: "confirmPassword", children: "\u786E\u8BA4\u5BC6\u7801" }), _jsx("input", { id: "confirmPassword", name: "confirmPassword", type: "password", placeholder: "\u8BF7\u518D\u6B21\u8F93\u5165\u5BC6\u7801", minLength: 8, required: true, autoComplete: "new-password" })] }), _jsx("button", { type: "submit", disabled: loading, onClick: () => console.log('[RegisterPage] Button clicked'), children: loading ? '注册中...' : '注册' })] }), _jsxs("p", { children: ["\u5DF2\u6709\u8D26\u53F7\uFF1F", _jsx("a", { href: "/login", children: "\u7ACB\u5373\u767B\u5F55" })] })] }));
}
//# sourceMappingURL=register-page.js.map